import { Box } from "@mui/material";
import React, { useState } from "react";
import RecordsHeader from "./RecordsHeader";
import {
  CustomTabPanel2,
} from "../Common/UI/TabPanel";
// import RecordsList from "./RecordsList";
// import { pageSize } from "../Common/styles/table";
import { useAppSelector } from "../../Redux/hooks";
import { permissions } from "../../utils/roles";
import ParticipantList from "./ParticipantList";
// import { setParticipantsPage } from "../../Redux/reducers/participantsSlice";

// const tabs = [
//   {
//     key: "list",
//     label: "List",
//   },
//   {
//     key: "visit",
//     label: "Visit",
//   },
//   {
//     key: "form",
//     label: "Form",
//   },
// ];

const Records = () => {
  // const dispatch = useAppDispatch();
  const [tab, setTab] = useState("list");
  const studyPermissions = useAppSelector(
    (state) => state.study.studyPermissions
  );
  const dataEditable = useAppSelector((state) => state.study.dataEditable);
  // const tabChange = (event: React.ChangeEvent<{}>, newTab: string) => {
  //   setTab(newTab);
  //   dispatch(setParticipantsPage({ page: 0, pageSize: pageSize }));
  // };

  const [addUser] = useState(
    studyPermissions.includes(permissions.addParticipant) && dataEditable
  );

  return (
    <Box>
      <RecordsHeader addUser={addUser} />
      {/* <Box sx={{ borderTop: 1, borderColor: "#E5E7EB" }}>
        <StyledTabs value={tab} onChange={tabChange}>
          {tabs.map((tab, index) => (
            <StyledTab
              key={tab.key}
              label={tab.label}
              value={tab.key}
              {...a11yProps(index)}
            />
          ))}
        </StyledTabs>
      </Box> */}
      <Box
        sx={{
          height: "calc(100vh - 136px)",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CustomTabPanel2 value={tab} index={tab}>
          <ParticipantList type={tab} />
        </CustomTabPanel2>
      </Box>
    </Box>
  );
};

export default Records;
